import request from '@/utils/request';

export function getReferMessage(values) {
  return request('/member-report/query/queryMemberStore', {
    method: 'POST',
    data: values,
  });
}
export function getDownLoadList(values) {
  return request('/member-report/downloadOrderSalesDetail', {
    method: 'POST',
    data: values,
  });
}

// 获取门店树形列表
export function getStoreTreeList() {
  return request('/store/queryTreeList', {
    method: 'GET',
  });
}

export function getStoreType() {
  return request('/member-report/query/queryStoreType', {
    method: 'POST',
  });
}
